import { apiClient } from "../../client";
import { PaginatedResponse } from "../role.repository";

export interface SubChannel {
    id: number;
    tenant_id: number;
    en_name: string;
    ar_name?: string | null;
    status: number;
    created_by?: number;
    updated_by?: number;
    created_at: number;
    updated_at: number;
}

export interface CreateSubChannel {
    tenant_id: number;
    en_name: string;
    ar_name?: string;
    status?: number;
}

export interface UpdateSubChannel {
    tenant_id?: number;
    en_name?: string;
    ar_name?: string;
    status?: number;
}

class SubChannelRepository {

    async getAll(page: number = 1, limit: number = 10, filter?: any): Promise<PaginatedResponse<SubChannel>> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filter.search) {
            params.append('search', filter.search);
        }

        if (filter.status) {
            params.append('status', filter.status);
        }

        if (filter.sub_channel_id) {
            params.append('sub_channel_id', filter.sub_channel_id)
        }

        return apiClient.get<PaginatedResponse<SubChannel>>(`/sub-channels?${params.toString()}`);

    }

    async getBYId(id: number): Promise<SubChannel> {

        return apiClient.get<SubChannel>(`/sub-channels/${id}`);

    }

    async create(data: CreateSubChannel): Promise<SubChannel> {
        return apiClient.post<SubChannel>('/sub-channels', data);

    }

    async update(id: number, data: UpdateSubChannel): Promise<SubChannel> {
        return apiClient.put<SubChannel>(`/sub-channels/${id}`, data);

    }

    async remove(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/sub-channels/${id}`);

    }

    async exportToExcel(filters?: any): Promise<Blob> {

        const params = new URLSearchParams();

        if (filters?.search) {
            params.append('search', filters.search);
        }

        if (filters?.status) {
            params.append('status', filters.status);
        }

        if (filters?.sub_channel_id) {
            params.append('sub_channel_id', filters.sub_channel_id.toString())
        }

        const baseUrl = `/sub-channels/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }

}

export const subchannelRepository = new SubChannelRepository();